import React, { useState } from "react";

// region Imports - Molecules
import EnvironmentTabButtons, { IEnvironmentControllerTabs } from "@molecules/EnvironmentTabButtons";
import FormEnvParams from "@molecules/FormEnvParams";
import FormEnvColors from "@molecules/FormEnvColors";
import FormEnvIcons from "@molecules/FormEnvIcons";
// endregion Imports - Molecules
// region Imports - Styles
import * as Styled from "./styles";
// endregion Imports - Styles

const EnvironmentSettings: React.FC = () => {

  const [
    environmentControllerTabs,
    setEnvironmentControllerTabs
  ] = useState<IEnvironmentControllerTabs>("params");

  return (
    <Styled.Container>
      <EnvironmentTabButtons
        environmentControllerTabs={environmentControllerTabs}
        setEnvironmentControllerTabs={setEnvironmentControllerTabs}
      />
      <Styled.Content>
        {environmentControllerTabs === "params" && (
          <FormEnvParams />
        )}
        {environmentControllerTabs === "colors" && (
          <FormEnvColors />
        )}
        {environmentControllerTabs === "icons" && (
          <FormEnvIcons />
        )}
      </Styled.Content>
    </Styled.Container>
  );
};

export default EnvironmentSettings;